import { render, staticRenderFns } from "./AuthorBox.vue?vue&type=template&id=edd1bf3e"
import script from "./AuthorBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthorBox.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports